import(/* webpackMode: "eager" */ "/app/app/[lang]/register/page.tsx");
